export const DEFAULT_FOLDER_ID = 0;
